export const webinarSingleUseAllowed = window.newBillingConfig?.webinarSingleUseAllowed || false;
